import {useRef, useState} from 'react';
import styles from './founderCreation.module.scss';
import {useNavigate} from 'react-router-dom';
import {toast} from 'react-toastify';
import FounderCard from './founderCard';
import {Button} from '@dabafinance/react-components';
import plusIcon from 'images/plus-circle.png';

const blankCard = () => ({
  imgUrl: '',
  previewUrl: '',
  fullname: '',
  ceo: '',
  twitter: '',
  sex: '',
  role: '',
  linkedin: '',
  description: '',
});

const FounderCreation = () => {
  const [addCard, setAddCard] = useState([blankCard()]);
  const [finishing, setFinishing] = useState(false);
  // Each founder card registers its live save state here so "Finish" can
  // persist any members the admin filled in but didn't individually "Save".
  const cardsRef = useRef({});

  const navigate = useNavigate();

  const addAnother = () => {
    setAddCard(current => [...current, blankCard()]);
  };

  const onDelete = id => {
    delete cardsRef.current[id];
    const filteredFormValue = addCard.filter((item, index) => index !== id);
    setAddCard(filteredFormValue);
  };

  const handleFinish = async () => {
    const cards = addCard
      .map((_, index) => cardsRef.current[index])
      .filter(Boolean);

    // A card the admin started but that can't be saved yet (missing required
    // fields) would be silently lost on finish — warn instead of dropping it.
    const incomplete = cards.filter(
      card => !card.saved && card.hasData && !card.canSave,
    );
    if (incomplete.length) {
      return toast.error(
        'Each team member needs a full name and job title. Complete or remove them before finishing.',
      );
    }

    const toSave = cards.filter(card => !card.saved && card.canSave);
    if (toSave.length) {
      setFinishing(true);
      const results = await Promise.all(toSave.map(card => card.save()));
      setFinishing(false);
      // A save failed (error already toasted) — stay so nothing is lost.
      if (results.some(result => result === false)) return;
    }

    navigate('/dashboard/opportunities/startups/');
  };

  return (
    <div>
      <div className={styles['founder-container']}>
        <h2 className={styles['section-title']}>Founders and team</h2>
        <p className={styles['section-hint']}>
          Add the company&apos;s founders and key team members, then finish.
          Team members you add are saved when you finish — you don&apos;t need
          to save each one.
        </p>
        <div>
          <div>
            {addCard?.map((event, index) => (
              <div key={index}>
                <FounderCard
                  cardsRef={cardsRef}
                  index={index}
                  DeleteFounder={() => onDelete(index)}
                  event={event}
                />
              </div>
            ))}
            <div onClick={addAnother} className={styles['add-founder']}>
              <img src={plusIcon} alt="add-founder" />
              <span>Add Founder</span>
            </div>
          </div>
          <div className={styles['button-wrapper']}>
            <Button
              onClick={handleFinish}
              disabled={finishing}
              className={styles.button}
              label={finishing ? 'Saving...' : 'Finish'}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default FounderCreation;
